import axios from "axios";

export async function saveSongAPI(action, uniqueName) {
  const metaData = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    withCredentials: true,
  };

  const startSecond = action.song.startSecond ? action.song.startSecond : 0;
  const endSecond = action.song.endSecond ? action.song.endSecond : 20;

  var data = new FormData();
  data.append("song_name", action.song.songName);
  data.append("unique_name", uniqueName);
  data.append("song_to_upload", action.songToUpload);
  data.append("sample_start", startSecond);
  data.append("sample_end", endSecond);
  data.append("file", action.audioData ? action.audioData : new Blob());

  return new Promise((resolve) => {
    axios
      .post(`${process.env.REACT_APP_BACKEND}/save_song`, data, metaData)
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e.response.data);
      });
  });
}
